import { render, staticRenderFns } from "./EdittSysConfigDialog.vue?vue&type=template&id=4dd3a7cd&scoped=true&lang=pug&"
import script from "./EdittSysConfigDialog.vue?vue&type=script&lang=ts&"
export * from "./EdittSysConfigDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd3a7cd",
  null
  
)

export default component.exports